import { Alert, Flex, Typography } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { useIdoInfo } from '../../../common/hooks/useIdoInfo';
import { ContributionForm } from '../common/ContributionForm/ContributionForm';

export const Contribution: FC = () => {
  const { currentRound } = useIdoInfo();

  return (
    <Flex col>
      <Flex.Item marginBottom={4}>
        <Alert
          showIcon
          type="warning"
          message={
            <Typography.Body>
              Be aware that there are many more whitelisted tokens than real
              ones, so others can claim your SPF faster
            </Typography.Body>
          }
        />
      </Flex.Item>
      <ContributionForm
        title="Public Contribution"
        proxyNft={currentRound?.proxyNFTIds[0] || ''}
        whitelistTokenId={currentRound?.whitelistTokenIds[0] || ''}
      />
    </Flex>
  );
};
